import Mesh from './Mesh'
import { createCurvyPage, createPlane, createCoverPage } from '../helpers/3DEngineHelper'
import { ease, Easing } from '../helpers/EaseHelper'
import { createPageMaterial, createMatNormal, getInkMat} from '../helpers/MaterialHelper'

/**
 * class Book
 */
class Book extends Mesh {

  constructor () {
    super()
    this._openRatio = 0
    this.desktop = createPlane(45.5412, 26.35, 1, 1, createMatNormal('Desk'))
    this.book = createCurvyPage(getInkMat('book'))
    this.drawbox = createPlane(3.55, 3.55, 1, 1, createMatNormal('SCENE-3D'))
    this.pageRight = createCurvyPage(createMatNormal('Interior-Right'))
    this.pageLeft = createCurvyPage(createMatNormal('Page-recto'))
    this.cover = createCoverPage(createMatNormal('Cover'), createMatNormal('Interior-Left'))
    this.meshes.push(this.desktop, this.book, this.drawbox, this.pageRight, this.pageLeft, this.cover)
  }

  get openRatio () {
    return this._openRatio
  }

  set openRatio (value) {
    this._openRatio = value
    if (!this.pageLeft || !this.pageLeft.material) return
    this.cover.rotation.y = -Math.PI * Math.min(value * 3, 1)
    this.cover.position.z = 0.24 * (1 - value) - 0.3
    this.pageLeft.material.uniforms.openRatio.value = value
    this.pageLeft.position.z = 0.02 + value * 1.5
    this.pageRight.position.z = 0.01 + value * 1.5
    // this.pageRight.material.uniforms.opacity.value = 1.0 - Math.pow(value, 10)
  }

  show (animated = true) {
    this.container.visible = true
  }

  hide (animated = true) {
    this.container.visible = false
  }

  setPageMaterials (names) {
    const getLocalIndexMatFromName = name => this.materials.findIndex(mat => mat.name === name)
    const getMapFromMatName = name => this.materials.find(mat => mat.name === name).map
    const replaceMat = (name, index, list) => {
      const matIndex = getLocalIndexMatFromName(name)
      this.materials[matIndex] = createPageMaterial(name, getMapFromMatName(name), this.uniforms)
    }
    names.map(replaceMat)
  }

  loadComplete () {
    this.setPageMaterials(['Page-recto', 'Interior-Right'])
    this.desktop.position.x = 0.0
    this.desktop.position.y = 0.0
    this.desktop.position.z = -0.3
    this.desktop.scale.set(1.1, 1.1, 1.1)
    this.book.position.z = -0.01
    this.drawbox.position.z = 0.0
    this.pageRight.position.z = 0.01
    this.pageLeft.position.z = 0.02
    this.cover.position.z = 0.15
  }

  setSize (width, height) {
    this.drawbox.scale.set(Math.max(width / height, 4.98 / 3.55), 1, 1)
  }

  open () {
    ease(this)
    .to({openRatio: 1}, 3000)
    .easing(Easing.Cubic.InOut)
    .start()
  }

  close () {
    ease(this)
    .to({openRatio: 0}, 4000)
    .easing(Easing.Cubic.Out)
    .start()
  }
}
export default Book


// WEBPACK FOOTER //
// ./src/scripts/webgl/Book.js